import { createSlice } from '@reduxjs/toolkit';
import { transactionsApi } from '@/redux/api/transactions';

interface WalletTransfersState {
  fromWallet: string | null;
  toWallet: string | null;
  amount: number | null;
}

const initialState: WalletTransfersState = {
  fromWallet: null,
  toWallet: null,
  amount: null,
};

const walletTransfersSlice = createSlice({
  name: 'walletTransfers',
  initialState,
  reducers: {
    setFromWallet: (state, action) => {
      state.fromWallet = action.payload;
    },
    setToWallet: (state, action) => {
      state.toWallet = action.payload;
    },
    setAmount: (state, action) => {
      state.amount = action.payload;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addMatcher(transactionsApi.endpoints.walletTransfer.matchFulfilled, (state) => {
      state.fromWallet = null;
      state.toWallet = null;
      state.amount = null;
    });
  },
});

export const { setFromWallet, setToWallet, setAmount, reset } = walletTransfersSlice.actions;

export const walletTransfersReducer = walletTransfersSlice.reducer;
